import { getUid } from "../../auth";
import {
  doc,
  getFirestore,
  collection,
  updateDoc,
  setDoc,
  arrayUnion,
  getDocs,
  getDoc,
  orderBy,
  query,
  arrayRemove,
  deleteDoc,
  runTransaction,
} from "firebase/firestore";
// import { getCollectionRef, getDocRef } from "../utils";

export async function getCalendarEvents() {
  const db = getFirestore();
  const events = {};
  const eventsCollection = collection(db, `/calendar`);
  const querySnapshot = await getDocs(eventsCollection);

  querySnapshot.forEach((doc) => {
    events[doc.id] = { ...doc.data(), id: doc.id, type: "main-calendar" };
  });

  return events;
}
